import client from 'src/helpers/authenticated-axios'

export default {
  getRedisMemoryUsageTimeSeries(body) {
    let url = '/time_series/datapoints';

    return client().post(url, body)
  }
}
